import axios from 'axios';

const API_TIMEOUT_MS = Number(process.env.REACT_APP_API_TIMEOUT_MS || 120000);

// Create an Axios instance
const api = axios.create({
  baseURL: 'https://whale-app-fk7fs.ondigitalocean.app', 
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: API_TIMEOUT_MS,
});

// Add an interceptor to check the token validity
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      
      localStorage.removeItem('token');
      localStorage.removeItem('role');
    }
    return Promise.reject(error);
  }
);

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
